import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {TikTokLikeTiktokTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/likeTiktok';
import {useTranslation} from 'react-i18next';

const TikTokLikeTiktokTriggerActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<TikTokLikeTiktokTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-tiktok', {
    keyPrefix: 'triggers.like-tiktok',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} />;
};

export default TikTokLikeTiktokTriggerActionCtaComponentPreview;
